const {jQuery: $} = window;

import Utils from "../utils.class";

/**
 * Story timeline layout (builder/layouts/timeline.php): fills the track and fades the items up
 * when the timeline scrolls into view. Skipped for reduced motion or without IntersectionObserver,
 * so the timeline simply shows as-is.
 */
export default class Timeline {

    #theme;

    /**
     * @param {Theme} theme
     */
    constructor(theme) {
        this.#theme = theme;

        Utils.log("Registered Timeline Layout.");
    }

    events() {
        const $timelines = $('[data-story-timeline]');
        const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        if (!$timelines.length) {
            return;
        }

        // Reduced motion: stop the looping circle videos on their poster/first frame
        if (reduceMotion) {
            $timelines.find('.story-timeline__video').each(function () {
                this.removeAttribute('autoplay');
                this.pause();
            });
        }

        if (reduceMotion || typeof IntersectionObserver === 'undefined') {
            return;
        }

        const observer = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    $(entry.target).addClass('is-visible');
                    observer.unobserve(entry.target);
                }
            });
        }, {threshold: 0.2});

        $timelines.each(function () {
            $(this).addClass('is-animated');
            observer.observe(this);
        });
    }

}
